export function get(data, key) {
    const arrs = key.split('.');
    for (let i = 0; i < arrs.length; i++) {
        const key = arrs[i];
        data = data[key];
        if (!data) {
            return data;
        }
    };
    return data;
};
export function set(data, key, value) {
    const arrs = key.split('.');
    if (arrs.length === 1) {
        data.$set(data, key, value)
    }else {
        const field = arrs.pop()
        const obj = get(data, arrs.join('.'));
        data.$set(obj, field, value)
    }
}